import React from 'react';
import {Image} from '../../../../components/image/image';
import HeroBanner from '../hero-banner/hero-banner';

interface RegisterSectionProps {
    lightBeamsImage?: string;
    cloudEffectImage?: string;
    artistListImage?: string;
    title?: string;
    subTitle?: string;
    renderRegisterForm?: () => React.JSX.Element;
}

const RegisterSection: React.FC<RegisterSectionProps> = ({
    lightBeamsImage,
    cloudEffectImage,
    artistListImage,
    title = 'ĐĂNG KÝ NHẬN VÉ',
    subTitle = 'Nhanh tay đăng ký nhận vé ngay!',
    renderRegisterForm,
}) => {
    return (
        <div id="register-section" className={`w-full mx-auto max-w-[2000px] relative overflow-hidden`}>
            {/* Background Image với aspect ratio cố định */}
            <div className="absolute inset-0 w-full">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/registration-background.webp"
                    alt="Register Background"
                    fill
                    className="object-cover"
                    priority
                />
                {/* Overlay để đảm bảo text dễ đọc */}
                <div className="absolute inset-0 bg-[#0803E0]/60"></div>
            </div>
            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-flare-2.webp"
                alt="Pink Flare"
                width={900}
                height={900}
                className="absolute -top-[8%] -right-[20%] xl:-bottom-60 xl:right-[-450px] xl:top-[-250px] mix-blend-lighten"
            />

            <Image
                src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-flare-2.webp"
                alt="Pink Flare"
                width={900}
                height={900}
                className="absolute top-[10%] -left-[30%] mix-blend-lighten"
            />

            {/* Bottom Background Image giữ nguyên nếu muốn layer effect */}
            <div className="absolute inset-x-0 bottom-0 h-1/2 sm:h-1/2 md:h-1/2 lg:h-1/2">
                <Image
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/registration-background-2.png"
                    alt="Bottom Background 2"
                    fill
                    className="object-cover object-top mix-blend-lighten opacity-80"
                />
            </div>
            <main
                className="relative w-full max-w-[1200px] mx-auto flex flex-col justify-start items-center gap-[56px] xl:gap-0 py-11 md:py-[80px]"
                style={{minHeight: '800px'}}>
                <div className="flex flex-col justify-center items-center">
                    <h3 className="font-kpz_font text-white md:text-[48px] text-[36px] font-bold">{title}</h3>
                    <span className="font-montserrat text-white text-[18px] md:text-[24px]">{subTitle}</span>
                </div>
                {renderRegisterForm?.()}
            </main>
        </div>
    );
};

export default RegisterSection;
